import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, split, Observable } from 'apollo-link';
import VueApollo from 'vue-apollo';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createUploadLink } from 'apollo-upload-client';

import QDatetimePicker from 'quasar-app-extension-qdatetimepicker/src/component/QDatetimePicker.js';

import './quasar';

Vue.component('q-datetime-picker', QDatetimePicker({ ssrContext: false }));

// import QFlashcardBoot from "@quasar/quasar-app-extension-qflashcard/src/boot/qflashcard";
const GC_AUTH_TOKEN = 'token';

const httpOptions = {
  uri: process.env.VUE_APP_HOST
};
const httpLink = new HttpLink({
  uri: process.env.VUE_APP_HOST
});

/* const wsLink = new WebSocketLink({
    uri: 'wss://homologacao.crm.cancer.org/subscriptions',
    options:{
        reconnect: false
    }
}) */

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem(GC_AUTH_TOKEN);
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : null
    }
  });
  return forward(operation).map(response => {
    if (response.hasOwnProperty('errors')) {
      if (response.errors.length) {
        if (response.errors[0].hasOwnProperty('debugMessage')) {
          if (response.errors[0].debugMessage == 'Unauthenticated.') {
            window.location.href = '/#/login';
          }
        }
      }
    }
    return response;
  });
});

// use with apollo-client

/* const link = split(
    // split based on operation type
    ({query}) => {
        const definition = getMainDefinition(query)
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
    },
    wsLink,
    authMiddleware.concat(httpLink)
) */
const apolloClient = new ApolloClient({
  link: authMiddleware.concat(createUploadLink(httpOptions)),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  }
});

Vue.use(VueApollo);

// Vue.use(QFlashcardBoot)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: 'loading'
  }
});

Vue.config.productionTip = true;

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app');
